[
  {
    "code": "SZ-HH",
    "name": "Hhohho"
  },
  {
    "code": "SZ-LU",
    "name": "Lubombo"
  },
  {
    "code": "SZ-MA",
    "name": "Manzini"
  },
  {
    "code": "SZ-SH",
    "name": "Shiselweni"
  }
]